import { Link } from "react-router-dom";
import { Phone, MessageCircle, PenLine } from "lucide-react";
import { BUSINESS } from "../data/site";

export default function MobileBottomBar() {
  const waLink = `https://wa.me/${BUSINESS.whatsapp.replace(/[^0-9]/g, "")}`;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-3 border-t border-brand-border bg-white/95 backdrop-blur-md lg:hidden" data-testid="mobile-bottom-bar">
      <a href={`tel:${BUSINESS.phone.replace(/[^0-9+]/g, "")}`} className="flex flex-col items-center justify-center gap-0.5 py-3 text-brand-ink" data-testid="bottom-call">
        <Phone className="h-5 w-5 text-brand-primary" />
        <span className="text-[11px] font-600">Call</span>
      </a>
      <a href={waLink} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center gap-0.5 border-x border-brand-border py-3 text-brand-ink" data-testid="bottom-whatsapp">
        <MessageCircle className="h-5 w-5 text-brand-primary" />
        <span className="text-[11px] font-600">WhatsApp</span>
      </a>
      <Link to="/contact" className="flex flex-col items-center justify-center gap-0.5 bg-brand-primary py-3 text-white" data-testid="bottom-enquire">
        <PenLine className="h-5 w-5" />
        <span className="text-[11px] font-600">Enquire</span>
      </Link>
    </div>
  );
}
